const serviceBazarPk = {
	sidebar: {
		categoriesTitle: 'سروس کی اقسام',
		providersTitle: 'سروس فراہم کنندگان'
	},
	search: {
		placeholder: 'سروس تلاش کریں...'
	},
	card: {
		provider: 'سروس فراہم کنندہ',
		experience: 'تجربہ',
		book: 'بک کریں',
		contact: 'رابطہ کریں'
	},
	empty: {
		title: 'کوئی سروس نہیں ملی',
		subtitle: 'براہ کرم فلٹر یا تلاش تبدیل کریں',
		clear: 'تمام فلٹر صاف کریں'
	}
};

export default serviceBazarPk;


